<!--
 * @Author: wh
 * @Date: 2020-07-25 17:21:52
 * @LastEditTime: 2020-07-31 11:14:00
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \Web\JiYun.Mobile\src\views\customerTerminal\feedback\List.vue
-->
<template>
    <div class="feedbackList">
        <van-nav-bar
            title="意见反馈"
            left-text=""
            left-arrow
            @click-left="onClickLeft"
        >
            <template #right>
                <van-icon name="plus" size="18" @click="newFeedback"></van-icon>
            </template>
        </van-nav-bar>
        <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
            <van-list
                v-model="loading"
                :finished="finished"
                finished-text="没有更多了"
                @load="onLoad"
            >
                <template v-for="(item) in list">
                    <div
                        class="materialPlan-item"
                        :key="item.Id"
                        @click="toInfo(item)"
                    >
                        <i class="corner-marker" v-if="!item.Reply"><span>未回复</span></i>
                        <i class="corner-marker" v-else><span>已回复</span></i>
                        <ul>
                            <li class="tit">
                                <span class="iconfont icondanjubianhao"></span>
                                <span class="info">合同编号：{{ item.ContractNumber }}</span>
                            </li>
                            <li>
                                <span class="pre-icon materialPlan01"></span>
                                <span class="info">工程名称：{{ item.EngineeringName }}</span>
                            </li>
                            <li>
                                <span class="pre-icon materialPlan06"></span>
                                <span class="info">签订日期：{{ item.SigningDate }}</span>
                            </li>
                            <li>
                                <span class="pre-icon materialPlan06"></span>
                                <span class="info">供料时间：{{ item.SupplyFirstTime }}</span>
                            </li>
                            <li>
                                <span class="pre-icon materialPlan07"></span>
                                <span class="info">已供方量：{{ item.SupplyVolume }}</span>
                            </li>
                        </ul>
                    </div>
                </template>
            </van-list>
        </van-pull-refresh>
    </div>
</template>

<script>
export default {
    components: {},
    props: {},
    data() {
        return {
            loading: false,
            finished: false,
            // 下拉刷新
            isLoading: false,
            page: {
                pageindex: 0,
                pagesize: 3,
            },
            list: [],
        };
    },
    watch: {},
    computed: {},
    created() {},
    mounted() {
    },
    methods: {
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        newFeedback() {
            this.$router.isBack = 2;
            this.$router.push({ name: 'newFeedback', params: { type: 'new' } });
        },
        toInfo(data) {
            this.$router.isBack = 2;
            this.$router.push({ name: 'feedbackInfo', params: { infoData: data } });
        },
        onLoad() {
            if (this.isLoading) {
                this.list = [];
                this.isLoading = false;
            }
            this.page.pageindex += 1;
            this.getPage();
        },
        // 下拉刷新11
        onRefresh() {
            this.page.pageindex = 0;
            this.finished = false;
            this.loading = true;
            this.onLoad();
        },
        async getPage() {
            const res = await this.getPageApi();
            if (res) {
                this.loading = false;
                this.isLoading = false;
                if (res.total) {
                    this.total = true;
                    this.list = this.list.concat(res.rows);
                    if (this.list.length >= res.total) {
                        this.finished = true;
                    }
                } else {
                    this.total = false;
                    this.finished = true;
                }
            }
        },
        getPageApi() {
            const queryStr = '?keywords=&pageindex=' + this.page.pageindex + '&pagesize=' + this.page.pagesize;
            return this.$axios.$post('/interfaceApi/sale/feedback/get_page' + queryStr, { defEx: true });
        },
    },
};
</script>
<style lang="stylus">
    .feedbackList
        height 100%
        background #F0F0F0
        .van-pull-refresh
            height calc(100% - 45rpx)
            padding 15rpx 15rpx 0 15rpx
            .materialPlan-item
                width 100%
                background #ffffff
                margin-bottom 15rpx
                position relative
                overflow hidden
                padding 16rpx
                color #666666
                font-size 14rpx
                .connect
                    position absolute
                    bottom 70rpx
                    right 15rpx
                    padding 5rpx 15rpx
                    border 1px solid #5588F1
                    border-radius 4rpx
                    color #5588F1
                li
                    overflow hidden
                    margin-bottom 10rpx
                    .pre-icon
                        width 16rpx
                        height 16rpx
                        float left
                        background-size 100% 100%
                        background-repeat no-repeat
                        display inline-block
                        margin 2rpx 10rpx 0 0
                        &.materialPlan01
                            background-image url(./../../../assets/images/icons/icon_gy_3.png)
                        &.materialPlan06
                            background-image url(./../../../assets/images/icons/icon_gy_7.png)
                        &.materialPlan07
                            background-image url(./../../../assets/images/icons/icon_30.png)
                    .info
                        float left
                        width calc(100% - 26rpx)
                    &.tit
                        font-size 16rpx
                        color #061F3E
                        .icondanjubianhao
                            font-size 18rpx
                            margin 3rpx 8rpx 0 0
                            float left
                            color #0189FC
                .corner-marker
                    width 60rpx
                    height 60rpx
                    position absolute
                    right -30rpx
                    top -30rpx
                    transform rotate(45deg)
                    -webkit-transform rotate(45deg)
                    -moz-transform rotate(45deg)
                    // line-height 100rpx
                    background #E60000
                    span
                        position absolute
                        bottom 2rpx
                        width 100%
                        text-align center
                        color #fff
                        font-size 10rpx!important
</style>